import { useState } from 'react';

export default function Navigation() {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-sm z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <h1 className="text-3xl font-bold text-sky-600" style={{ fontFamily: '"Pacifico", serif' }}>
              Dario Parapente
            </h1>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-sky-600 transition-colors whitespace-nowrap cursor-pointer">
              Home
            </button>
            <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-sky-600 transition-colors whitespace-nowrap cursor-pointer">
              About
            </button>
            <button onClick={() => scrollToSection('experiences')} className="text-gray-700 hover:text-sky-600 transition-colors whitespace-nowrap cursor-pointer">
              Experiences
            </button>
            <button onClick={() => scrollToSection('gallery')} className="text-gray-700 hover:text-sky-600 transition-colors whitespace-nowrap cursor-pointer">
              Gallery
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="text-gray-700 hover:text-sky-600 transition-colors whitespace-nowrap cursor-pointer">
              Testimonials
            </button>
            <button onClick={() => scrollToSection('booking')} className="bg-sky-600 text-white px-6 py-2.5 rounded-full hover:bg-sky-700 transition-colors whitespace-nowrap cursor-pointer">
              Book Now
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`ri-${isOpen ? 'close' : 'menu'}-line text-2xl text-gray-700`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden pb-4">
            <div className="flex flex-col space-y-3">
              <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-sky-600 transition-colors py-2 text-left whitespace-nowrap cursor-pointer">
                Home
              </button>
              <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-sky-600 transition-colors py-2 text-left whitespace-nowrap cursor-pointer">
                About
              </button>
              <button onClick={() => scrollToSection('experiences')} className="text-gray-700 hover:text-sky-600 transition-colors py-2 text-left whitespace-nowrap cursor-pointer">
                Experiences
              </button>
              <button onClick={() => scrollToSection('gallery')} className="text-gray-700 hover:text-sky-600 transition-colors py-2 text-left whitespace-nowrap cursor-pointer">
                Gallery
              </button>
              <button onClick={() => scrollToSection('testimonials')} className="text-gray-700 hover:text-sky-600 transition-colors py-2 text-left whitespace-nowrap cursor-pointer">
                Testimonials
              </button>
              <button onClick={() => scrollToSection('booking')} className="bg-sky-600 text-white px-6 py-2.5 rounded-full hover:bg-sky-700 transition-colors text-center whitespace-nowrap cursor-pointer">
                Book Now
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
